import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { parseISO } from "date-fns";
import moment from "moment";

import styles from "./Update.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

class Update extends Component {
  state = {
    data: null,
    isLoading: false,
  };

  componentDidMount() {
    this.fetchUser();
  }

  fetchUser = () => {
    const { id } = this.props.match.params;

    axios
      .get(`/users/${id}`)
      .then((response) => {
        this.setState({
          data: {
            ...response.data,
            status: response.data.status.id.toString(),
          },
        });
      })
      .catch((error) => {
        if (error.response.data.code === 2001) {
          const errors = error.response.data.errors;
          toast.error(Object.values(errors[0])[0]);
        } else {
          toast.error(error.response.data.message);
        }
      });
  };

  render() {
    const { data } = this.state;

    const initialValues = {
      title: data ? data.title : "",
      firstName: data ? data.first_name : "",
      lastName: data ? data.last_name : "",
      userId: data ? data.user_id : "",
      phone: data ? data.phone : "",
      email: data ? data.email : "",
      dateOfBirth: data ? parseISO(data.date_of_birth) : "",
      pan: data ? data.pan : "",
      address: data ? data.address : "",
      status: data ? data.status : "",
    };

    const validationSchema = Yup.object({
      title: Yup.string().required("Title is required"),
      firstName: Yup.string()
        .required("First Name is required")
        .trim()
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
      lastName: Yup.string()
        .required("Last Name is required")
        .trim()
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
      userId: Yup.string()
        .required("User ID is required")
        .trim()
        .matches(
          /^[A-Z0-9]+$/,
          "Only alphabets and numbers are allowed for this field"
        ),
      phone: Yup.string()
        .required("Phone is required")
        .matches(/^[0-9]+$/, "Not a Valid Phone Number"),
      email: Yup.string()
        .required("Email is required")
        .matches(/^[a-zA-Z0-9.@_ ]+$/, "Invalid Email ID")
        .test("regex", "Invalid Email ID", (val) => {
          const regExpEmail = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i);
          return regExpEmail.test(val);
        }),
      dateOfBirth: Yup.string().required("Date of Birth is required"),
      pan: Yup.string().required("PAN is required"),
      address: Yup.string().required("Address is required"),
      status: Yup.string().required("Status is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = {
        title: values.title,
        first_name: values.firstName,
        last_name: values.lastName,
        user_id: values.userId,
        phone: values.phone,
        email: values.email,
        date_of_birth: moment(values.dateOfBirth).format("YYYY-MM-DD"),
        pan: values.pan,
        address: values.address,
        status: values.status,
      };

      axios
        .put(`/users/${data.id}`, formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    const titleOptions = [
      { value: "Mr", label: "Mr" },
      { value: "Miss", label: "Miss" },
      { value: "Mrs", label: "Mrs" },
    ];

    const statusOptions = [
      { value: "0", label: "Disabled" },
      { value: "1", label: "Enabled" },
    ];

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>Edit | Users | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Users</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/users">Users</Link>
              </li>
              <li>Edit</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Edit User</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              {data ? (
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                  render={({ setFieldValue }) => {
                    return (
                      <Form>
                        <div
                          className={["FormBody", styles.FormBody].join(" ")}
                        >
                          <FormikControl
                            control="select"
                            label="Title *"
                            name="title"
                            options={titleOptions}
                            value={data.title}
                            setFieldValue={setFieldValue}
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="First Name *"
                            name="firstName"
                            maxLength="30"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="Last Name *"
                            name="lastName"
                            maxLength="30"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="User ID *"
                            name="userId"
                            maxLength="12"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="Phone *"
                            name="phone"
                            maxLength="10"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="Email *"
                            name="email"
                            maxLength="150"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="PAN *"
                            name="pan"
                            maxLength="10"
                          />

                          <FormikControl
                            control="date"
                            type="text"
                            label="Date of Birth *"
                            name="dateOfBirth"
                            setFieldValue={setFieldValue}
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            label="Address *"
                            name="address"
                            maxLength="255"
                          />

                          <FormikControl
                            control="select"
                            label="Status *"
                            name="status"
                            options={statusOptions}
                            value={data.status}
                            setFieldValue={setFieldValue}
                          />
                        </div>

                        <div
                          className={["FormActions", styles.FormActions].join(
                            " "
                          )}
                        >
                          <Button
                            btnType="Primary"
                            type="Submit"
                            width="W100"
                            isLoading={this.state.isLoading}
                          >
                            Save
                          </Button>
                        </div>
                      </Form>
                    );
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Update;
